<template>
  <div>
    <div
      class="card-wrapper m-1 text-center w-175 h-233 xl:w-158 lg:w-123 lg:h-40"
      style="perspective: 600px;"
      v-for="(card, index) in classData"
      :key="index"
    >
      <div
        class="card-inner relative w-full h-full"
        style="transform-style: preserve-3d;"
      >
        <div id="face" class="front-face" style="backface-visibility: hidden;">
          <img :src="`${imgPath}${card.face}`" />
        </div>
        <div id="face" class="back-face" style="backface-visibility: hidden;">
          <div
            class="absolute bg-black bg-opacity-70 w-full h-full rounded-2xl xl:w-158 lg:w-123"
          ></div>
          <img :src="`${imgPath}${card.face}`" />
          <div
            class="absolute inset-0 m-auto flex flex-col items-center justify-center w-full h-full"
          >
            <div
              class="flex flex-col justify-center items-center cursor-pointer last:mt-5 lg:last:mt-2"
              v-for="(cls, clsIndex) in card.classes"
              :key="clsIndex"
              @click="openSlider(cls.id)"
            >
              <img :src="`${imgPath}${cls.icon}`" />
              <span
                class="text-pale-orange font-rajdhani font-semibold mt-1"
                v-html="cls.title"
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    classData: Array,
  },
  data: function() {
    return {
      imgPath: process.env.VUE_APP_IMG_URL,
    };
  },
  methods: {
    openSlider: function(id) {
      this.$store.commit('CLASS_SECTION/OPEN_WINDOW', id);
    },
  },
};
</script>

<style lang="postcss" scoped>
#face {
  backface-visibility: hidden;
}
#face {
  @apply w-full h-full absolute flex items-center justify-center;
}
.card-inner {
  transition: transform 0.4s;
  transform-style: preserve-3d;
}
.card-wrapper:hover .card-inner {
  transform: rotateY(180deg);
  transition: transform 0.3s;
}
.back-face {
  transform: rotateY(180deg);
}
</style>
